import { PageViewEvent } from '@shopify/events';
import { onDocumentReady } from '@theme/utilities';

function dispatchPageViewEvent() {
  /** @type {HTMLElement | null} */
  const templateElement = document.querySelector('main[data-template]');
  const template = templateElement?.dataset.template || '';

  document.dispatchEvent(
    new PageViewEvent({
      page: {
        template,
        title: document.title,
        url: window.location.href,
      },
    })
  );
}

onDocumentReady(dispatchPageViewEvent, { once: true });
document.addEventListener('smib:page:loaded', dispatchPageViewEvent);
